import styles from "../../styles/_sections/_mainAttractionDetail/visitorsCount.module.scss";

const VisitorsCount = () => {
  return (
    <div className={styles.container}>
      <h2>Setting up card inventory</h2>

      <div className={styles.field}>
        <label>Maximum number of visitors per hour</label>
        <input type="number" />
      </div>
    </div>
  );
};

export default VisitorsCount;
